import { Component } from '@angular/core';

@Component({
  selector: 'app-glossary-view',
  templateUrl: './glossary-view.component.html',
  styleUrls: ['./glossary-view.component.css']
})
export class GlossaryViewComponent {
}
